module.exports = __webpack_public_path__ + "static/media/react-redux.02d80920.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/react-redux.gif
// module id = 47
// module chunks = 0